import { keikka_person_add, keikka_person_remove } from "src/data/keikka/KeikkaFunctions";
import { checkResponse, getYYYYMMDD, parseJSONDate } from "../js/statics1";
import { asiakasPerson_cacheName, cache_read, cache_write } from "../js/CacheFunctions";
import {
  gridLog_add_pumppariAddedToKeikka,
  gridLog_add_pumppariRemovedFromKeikka,
} from "src/pages/Grid/GridLog/gridLogFunctions";

export async function pumppari_add_to_keikka(
  person,
  keikka,
  vehicleId,
  ownerAsiakasId,
  yyyymmdd,
  token,
  socket
) {
  if (!person || !keikka) return false;
  const personId = person.personId;
  const keikkaId = keikka.keikkaId;
  const r = await keikka_person_add(personId, keikkaId, token, socket, 1);
  if (r)
    await gridLog_add_pumppariAddedToKeikka(
      personId,
      keikkaId,
      vehicleId,
      ownerAsiakasId,
      yyyymmdd,
      token
    );
  return r;
}
export async function pumppari_remove_from_keikka(
  personId,
  keikkaId,
  vehicleId,
  ownerAsiakasId,
  yyyymmdd,
  token,
  socket
) {
  if (!personId || !keikkaId) return false;
  const r = await keikka_person_remove(personId, keikkaId, token, socket);
  await gridLog_add_pumppariRemovedFromKeikka(
    personId,
    keikkaId,
    vehicleId,
    ownerAsiakasId,
    yyyymmdd,
    token
  );
  return r;
}

export async function pumpparit_fetchList_for_keikka(keikkaId, token) {
  try {
    // get pumppari from keikkaPersons
    const url1 = import.meta.env.VITE_SERVER_URL + "/api/keikka/pumpparit/list/" + keikkaId;
    const response = await fetch(url1, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "pumppuClass:initPumppariList");
    if (!cResponse.success) return false;
    const result = cResponse.data;
    return result;
  } catch (error) {
    console.log(error);
    console.trace();
    return false;
  }
}

export async function pumpparit_fetchList_for_asiakas(asiakasId, token, yyyymmdd = null) {
  if (yyyymmdd === null) yyyymmdd = getYYYYMMDD(new Date());
  const listTypeId_pumpparit = 8; // pumpparit
  try {
    const addr = "/api/asiakas/person/list/" + asiakasId + "/" + listTypeId_pumpparit;
    const fullUrl = import.meta.env.VITE_SERVER_URL + addr;
    const c = cache_read(asiakasPerson_cacheName, fullUrl);
    if (c !== null) return c;
    const url = fullUrl;
    const response = await fetch(url, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    });
    const cResponse = await checkResponse(response, "pumppuClass:initPumppariList");
    if (!cResponse.success) return false;
    const data = cResponse.data;
    for (let i = 0; i < data.personList.length; i++) {
      const _person = data.personList[i];
      _person.asiakasPersonSettings = data.asiakasPersonSettings.filter(
        (item) => item.asiakasPersonId === _person.asiakasPersonId
      );
      _person.personSettings = data.personSettings.filter(
        (item) => item.personId === _person.personId
      );
      data.personList[i].is = {};
      for (let j = 0; j < _person.asiakasPersonSettings.length; j++) {
        const _setting = _person.asiakasPersonSettings[j];
        const startYYYYMMDD = getYYYYMMDD(_setting.startDate);
        const endYYYYMMDD = getYYYYMMDD(_setting.endDate);
        // check if _setting is valid for date formatted as yyyymmdd or null
        const isValidForDate =
          (startYYYYMMDD === null || yyyymmdd >= startYYYYMMDD) &&
          (yyyymmdd <= endYYYYMMDD || endYYYYMMDD === null);
        if (isValidForDate) {
          if (_setting.asiakasPersonSettingTypeId === 8) _person.is.pumppari = true;
          if (_setting.asiakasPersonSettingTypeId === 9) _person.is.työsuhteessa = true;
          if (_setting.asiakasPersonSettingTypeId === 15) _person.is.lomaseurannassa = true;
          if (_setting.asiakasPersonSettingTypeId === 16) _person.is.assignee = true;
        }

        _setting.startDate = parseJSONDate(_setting.startDate);
        _setting.endDate = parseJSONDate(_setting.endDate);
        if (_setting.asiakasPersonSettingTypeId === 9) {
          _person.startDate = _setting.startDate;
          _person.endDate = _setting.endDate;
        }
      }
    }
    cache_write(asiakasPerson_cacheName, fullUrl, data);
    return data;
  } catch (error) {
    console.log(error);
    console.trace();
    return false;
  }
}
